import { denormalize } from 'normalizr';
import reduceReducers from 'reduce-reducers';

import { createEntitiesReducer } from 'modules/common/redux';

import { types } from './actions';
import {
  addOnDefSchema,
  profitItemDefSchema,
  discountDefSchema,
} from './entities';

const initialState = {
  addOnDefIds: [],
  profitItemDefIds: [],
  discountDefIds: [],
  entities: {},
  globalExpediteOptions: null,
};

const entitiesReducer = createEntitiesReducer(
  ['addOnDefs', 'profitItemDefs', 'discountDefs'],
  [
    types.FETCH_ADD_ON_DEFS_SUCCESS,
    types.FETCH_PROFIT_ITEM_DEFS_SUCCESS,
    types.FETCH_DISCOUNT_DEFS_SUCCESS,
  ],
);

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.FETCH_ADD_ON_DEFS_SUCCESS:
      return {
        ...state,
        addOnDefIds: payload.result,
      };
    case types.FETCH_PROFIT_ITEM_DEFS_SUCCESS:
      return {
        ...state,
        profitItemDefIds: payload.result,
      };
    case types.FETCH_DISCOUNT_DEFS_SUCCESS:
      return {
        ...state,
        discountDefIds: payload.result,
      };
    case types.FETCH_GLOBAL_EXPEDITE_OPTIONS_SUCCESS:
      return {
        ...state,
        globalExpediteOptions: payload.globalExpediteOptions,
      };
    default:
      return state;
  }
};

export default reduceReducers(entitiesReducer, reducer, initialState);

const getScope = (state) => state.modules.quotes.quoteDetails;

export const getGlobalExpediteOptions = (state) =>
  getScope(state).globalExpediteOptions;

export const getAddOnDefs = (state) =>
  denormalize(
    getScope(state).addOnDefIds,
    [addOnDefSchema],
    getScope(state).entities,
  );

export const getProfitItemDefs = (state) =>
  denormalize(
    getScope(state).profitItemDefIds,
    [profitItemDefSchema],
    getScope(state).entities,
  );

export const getDiscountDefs = (state) =>
  denormalize(
    getScope(state).discountDefIds,
    [discountDefSchema],
    getScope(state).entities,
  );
